import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { options } from "./options";
import { ContentfulRichTextWrapper } from "./ContentfulRichText.styles";
export var ContentfulRichText = function(param) {
    var content = param.content, rules = param.rules;
    var document = content.text;
    return /*#__PURE__*/ _jsx(ContentfulRichTextWrapper, {
        textStyle: rules === null || rules === void 0 ? void 0 : rules.textStyle,
        children: documentToReactComponents(document, options)
    });
};
